
export const findCauseOfError = ( e, methodName ) => {
        console.log(e);
    if ( e.response ) {
        console.log(e.response);
        e.response?.data && console.warn( methodName,"response error", e.response.data  )
        e.response?.data?.message && console.warn( methodName,"response error", e.response.data.message );
    } else if (e.request ) {
        e.request?.data && console.warn( methodName,"request error", e.request.data )
        e.request?.data?.message && console.warn( methodName,"request error", e.request.data.message )
    } else {
        console.warn( methodName, "error", e?.message );
    }
}

export const displayErrorDialogPrompt = (e,defaultMessage) => {
    if (e?.response?.data?.dialogPrompt) {
        return e?.response?.data?.dialogPrompt !== 'Unknown' ? e?.response?.data?.dialogPrompt : defaultMessage;
    } else {
        return defaultMessage;
    }
}
